import { Base64 } from "js-base64"

// 默认缓存期限为7天
const DEFAULT_CACHE_TIME = 60 * 60 * 24 * 7

/**
 * 创建本地缓存对象
 * @param {string=} prefixKey -
 */
const createStorage = ({ prefixKey = "", storage = process.client ? localStorage : null } = {}) => {
  /**
   * 本地缓存类
   * @class Storage
   */
  class Storage {
    constructor() {
      this.prefixKey = prefixKey.toUpperCase()
      this.storage = storage
    }

    getKey(key) {
      return `${this.prefixKey}${key}`
    }

    /**
     * @description 设置缓存
     * @param {string} key 缓存键
     * @param {*} value 缓存值
     * @param {{ expire?: number, useBase64?: boolean }} options
     */
    set(key, value, { expire = DEFAULT_CACHE_TIME, useBase64 = false } = {}) {
      const stringData = useBase64 ? Base64.encode(JSON.stringify(value)) : JSON.stringify(value)

      // TODO 暂时屏蔽该结构，等项目改完使用 storage，再放开
      // const stringData = JSON.stringify({
      //   value,
      //   expire: expire !== null ? new Date().getTime() + expire * 1000 : null,
      // })

      if (process.server) {
        return
      }
      this.storage.setItem(this.getKey(key), stringData)
    }

    /**
     * 读取缓存
     * @param {string} key 缓存键
     * @param {*=} def 默认值
     * @param {{ def?: any, useBase64?: boolean }} options
     */
    get(key, { def = null, useBase64 = false } = {}) {
      if (process.server) {
        return
      }
      const item = this.storage.getItem(this.getKey(key))
      if (item) {
        try {
          const decodedItem = useBase64 ? Base64.decode(item) : item
          const data = JSON.parse(decodedItem)
          const { value, expire } = data
          if (expire === null || expire >= Date.now()) {
            return value
          }
          if (expire === undefined) {
            return data
          }
          this.remove(this.getKey(key))
        } catch (e) {
          return def
        }
      }
      return def
    }

    /**
     * 从缓存删除某项
     * @param {string} key
     */
    remove(key) {
      this.storage.removeItem(this.getKey(key))
    }

    /**
     * 清空所有缓存
     */
    clear() {
      this.storage.clear()
    }
  }

  return new Storage()
}

export const Storage = createStorage()
export default Storage
